module.exports = __webpack_public_path__ + "img/chara_line_6_white.1bae6778.png";